export const CUSTOMER_TABLE = 'customerTableEmployee'

export const CUSTOMER_PARTNER_TABLE = 'customerTablePartner'



// WEBPACK FOOTER //
// ./src/modules/customer/state/search/type.js